<template>
  <div class="add-btn-box">
    <input @change="uploadphoto" ref="clearFile" class="photoinput" type='file' accept="image/*,application/pdf" />
    <i class="el-icon-circle-plus-outline"></i>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    imgdata: {
      type: Object,
      default: () => { }
    },
    fileDir: {
      type: String,
      default: 'office',
    },
    watermark: {
      type: Boolean,
      default: true
    },
  },
  methods: {
    uploadphoto (e) {
      let files = e.target.files || e.dataTransfer.files;
      if (files.length > 0) {
        let file = files[0];

        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          let result = reader.result;
          if (file.type.indexOf('image') == 0 && file.type && /\.(?:jpeg|jpg|png|bmp|gif)$/.test(file.name.toLowerCase())) {
            let img = new Image();
            img.src = result;
            img.onload = () => {
              let imgbase64 = '';
              imgbase64 = this.compress(img, file);
              let blobimg = this.base64toBlob(imgbase64);
              let bloburl = URL.createObjectURL(blobimg);
              this.$refs.clearFile.value = ''; // 清空file文件

              let formData = new FormData();
              let token = this.sessionRead('token');
              let username = this.sessionRead('username');
	      let mso_id = this.sessionRead('mso_id');
              formData.append("token", token);
              formData.append("username", username);
	      formData.append("mso_id", mso_id);
              formData.append("fileDir", this.fileDir);
              formData.append("file", blobimg);
              let config = {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              };
              this.post('/api/upload/upload_blob', formData, config).then(response => {
                if (response.status == 'success') {
                  this.imgdata.srcList.push(bloburl);
                  this.imgdata.blobList.push(response.url);
                } else {
                  this.$notify({
                    message: '上傳圖片失敗',
                    type: 'error',
                    offset: 70,
                    duration: 5000
                  });
                }
              }).catch(error => {
                console.log(error);
              });

            }
          } else if (file.type.indexOf('application/pdf') == 0 && file.type && /\.(?:pdf)$/.test(file.name.toLowerCase())) {
            let blobimg = this.base64toBlob(result);
            let bloburl = require('../assets/pdf.png');
            this.$refs.clearFile.value = ''; // 清空file文件
            let formData = new FormData();
            let token = this.sessionRead('token');
            let username = this.sessionRead('username');
	    let mso_id = this.sessionRead('mso_id');
            formData.append("token", token);
            formData.append("username", username);
	    formData.append("mso_id", mso_id);
            formData.append("fileDir", this.fileDir);
            formData.append("file", blobimg);
            let config = {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            };
            this.post('/api/upload/upload_blob', formData, config).then(response => {
              if (response.status == 'success') {
                this.imgdata.pdfsrcList.push(bloburl);
                this.imgdata.pdfblobList.push(response.url);
              } else {
                this.$notify({
                  message: '上傳圖片失敗',
                  type: 'error',
                  offset: 70,
                  duration: 5000
                });
              }
            }).catch(error => {
              console.log(error);
            });
          } else {
            let notice = "對不起，僅支持JPEG/JPG/PNG/PDF格式文件";
            this.$notify({
              message: notice,
              type: 'error',
              offset: 70,
              duration: 5000
            });
            this.$refs.clearFile.value = ''; // 清空file文件
          }

        }
      }
    },
    compress_bf (img) {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      let width = img.width;
      let height = img.height;
      let fillwidth = 1024;
      let fillheight = parseInt(height * (fillwidth / width));
      canvas.width = fillwidth;
      canvas.height = fillheight;
      ctx.drawImage(img, 0, 0, fillwidth, fillheight);
      //进行压缩
      let ndata = canvas.toDataURL("image/jpeg", 0.9);
      return ndata;
    },
    /* 图片压缩方法-canvas压缩和加水印 */
    compress (image, file) {
      let canvas = document.createElement('canvas');
      let ctx = canvas.getContext('2d');

      let initSize = image.src.length;
      let { width } = image, { height } = image;
      canvas.width = width;
      canvas.height = height;

      let watermark = this.watermark;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0, width, height);
      if (watermark) {
        let fontSize = '25px';
        let fontWidth = 10;
        if (width > 1000 && height > 1000) {
          fontSize = '50px';
          fontWidth = 15;
        } else if (width > 500 && height > 500) {
          fontSize = '30px';
          fontWidth = 10;
        } else if (width < 300 && height < 300) {
          fontSize = '15px';
          fontWidth = 2;
        }

        //获取地点 时间 
        let dataa = new Date();
        // let copyText = dataa.getFullYear() + "/" + (dataa.getMonth() + 1) + "/" + dataa.getDate() + ' ' + 'Copy! Copy! Copy!';
        let copyText = 'Copy! Copy! Copy!';

        // 绘制水印到canvas上
        for (let i = 0; i < 50; i++) {
          ctx.rotate((-45 * Math.PI) / 180); // 水印初始偏转角度
          ctx.font = `${fontSize} 微软雅黑`; // 字体
          ctx.fillStyle = "rgba(0,0,0,0.3)"; // 字体颜色
          ctx.fillText(copyText, -(copyText.length * fontWidth), i * (height / 2) + 30);
          ctx.rotate((45 * Math.PI) / 180); // 把水印偏转角度调整为原来的，不然他会一直转
        }
      }


      // 进行最小压缩0.1
      let compressData = canvas.toDataURL(file.type || 'image/jpeg', 0.5);

      return compressData;
    },
    base64toBlob (base64Data) {
      var byteString;
      if (base64Data.split(",")[0].indexOf("base64") >= 0)
        byteString = atob(base64Data.split(",")[1]);
      else byteString = unescape(base64Data.split(",")[1]);
      var mimeString = base64Data
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], {
        type: mimeString
      });
    },
  },
  created () {
  }
}
</script>

<style scoped>
.add-btn-box i {
  font-size: 30px !important;
}
.add-btn-box {
  position: relative;
  color: rgba(0, 0, 255, 0.5);
  cursor: pointer;
}
.add-btn-box:hover {
  color: rgba(0, 0, 255, 0.8);
}

.photoinput {
  cursor: pointer;
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100% !important;
  height: 100% !important;
  opacity: 0;
  outline: none;
}
</style>